import VoucherFilter from "./voucher-filter";
import VoucherList from "./voucher-list";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {setVoucherSelectedRowKeys} from "../../reducers/voucher.reducer";
import {SORT_LIST_VOUCHER} from "../../utils/sort-list";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";

const VoucherPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_VOUCHER?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
        filterByType: filter['tipe voucher'] ?? []
    }
    const {
        data: voucherList,
        fetching: getVoucherList,
        isLoading
    } = useFetch(API.VOUCHER_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setVoucherSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getVoucherList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, filter, reload])

    return (
        <div className={"col px-10"}>
            <VoucherFilter/>
            <VoucherList data={voucherList?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default VoucherPage
